import React from 'react';
import { Input, PhoneInput } from 'containers/form';

export default function userForm(bemClasses) {
  return (
    <>
      <Input
        {...bemClasses('input')}
        dataBind="name"
        onChange={this.putStorageName}
        noLabel
        left
      />
      <PhoneInput
        {...bemClasses('input', 'phone')}
        dataBind="phone"
        onChange={this.putStoragePhone}
        noElementBefore
        noLabel
      />
      <Input
        {...bemClasses('input')}
        dataBind="email"
        onChange={this.putStorageEmail}
        noLabel
        left
      />
    </>
  );
}
